import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "./ProjectGroup.css";
import { projectList } from "../../api/project/projectApi";
import AddProjectGroup from "../Popup/AddProjectGroup/AddProjectGroup";
import DeleteProject from "../Popup/DeleteProjectGroup/DeleteProjectGroup";
import EditProjectGroup from "../Popup/EditProjectGroup/EditProjectGroup";
import UploadProject from "../Popup/DataUpload/DataUpload";
import delete_icon from "../../Images/utilImages/delete_icon.png";
import edit_icon from "../../Images/utilImages/edit_icon.png";
import database_upload_icon from "../../Images/utilImages/database_upload_icon.png";
import project_icon from "../../Images/utilImages/project_icon.png";
import more_icon from "../../Images/utilImages/more_icon.png";

// ✅ MUI Pagination import
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ProjectDataList from "../ProjectList/ProjectList";
import { useProject } from "../../ProjectContext";
import DeleteProjectGroup from "../Popup/DeleteProjectGroup/DeleteProjectGroup";

const ProjectGroup = ({refreshProjectGroups, setRefreshProjectGroups}) => {
  const { t } = useTranslation('menubar');
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [showCreateProject, setShowCreateProject] = useState(false);
  const [expandedId, setExpandedId] = useState(null);
  const [selectedProjectGroup, setSelectedProjectGroup] = useState(null);
  const [activePopup, setActivePopup] = useState(null);
  const { projectInfo, setProjectInfo } = useProject();

  // ✅ 페이지네이션 관련 상태
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await projectList();
        setProjects(res.data.data);
      } catch (error) {
        console.error("프로젝트 목록 조회 실패:", error);
      }
    };
    fetchProjects();
  }, [refreshProjectGroups]);

  // 정렬
  const sortedProjects = [...projects].sort((a, b) =>
    sortOrder === "asc"
      ? a.projectGroupId - b.projectGroupId
      : b.projectGroupId - a.projectGroupId
  );

  // 검색 필터
  const filteredProjects = sortedProjects.filter((p) =>
    p.projectGroupName.toLowerCase().includes(search.toLowerCase())
  );

  // ✅ 페이지 계산
  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentProjects = filteredProjects.slice(
    startIndex,
    startIndex + itemsPerPage
  );



  const handleCardClick = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));

    // ✅ Context에 선택한 프로젝트 그룹 ID 저장
    setProjectInfo((prev) => ({
      ...prev,
      groupId: prev.groupId === id ? null : id, // 클릭 시 같은 ID면 null 처리
    }));

    // console.log(
    //   "✅ 선택된 프로젝트 그룹 ID (Context):",
    //   projectInfo.groupId === id ? null : id
    // );
  };

  // 이후 ProjectDataList나 다른 컴포넌트에서
  // projectInfo.groupId로 선택된 그룹 ID 접근 가능

  

  const openPopup = (type, project) => {
    setSelectedProjectGroup(project);
    setActivePopup(type);
  };

  const closePopup = () => {
    setSelectedProjectGroup(null);
    setActivePopup(null);
  };

  // ✅ MUI 페이지네이션 변경 핸들러
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div>
      <div className="Tool_box">
        <input
          className="Search_Project_btn"
          placeholder={t("searchbox.des")}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      <div className="Project_List">
        {currentProjects.length > 0 ? (
          currentProjects.map((p) => (
            <div key={p.projectGroupId}>
              {/* 카드 */}
              <div
                className={`Project_Card ${
                  expandedId === p.projectGroupId ? "active" : ""
                }`}
                onClick={() => handleCardClick(p.projectGroupId)}
              >
                <div className="Project_CardHeader">
                  <div className="Project_CardBox">
                    <img
                      className="Project_icons"
                      src={project_icon}
                      alt="project icon"
                    />
                    {p.projectGroupName}
                  </div>
                  <div className="Project_CardBox">
                    <img
                      className={`More_icons ${
                        expandedId === p.projectGroupId ? "active" : ""
                      }`}
                      src={more_icon}
                      alt="more"
                    />
                  </div>
                </div>
              </div>

              {/* 확장 영역 */}
              {expandedId === p.projectGroupId && (
                <div className="Expanded_Section">
                  <div className="Expanded_Section_List">
                  <ProjectDataList groupId={p.projectGroupId} />

                  </div>
                  <div className="Expanded_Content">
                    <div className="Expanded_Box">
                      <img
                        className="Project_icon"
                        src={database_upload_icon}
                        alt="upload"
                      />
                      <button
                        className="ActionButton upload"
                        onClick={(e) => {
                          e.stopPropagation();
                          openPopup("upload", p);
                        }}
                      >
                        {t("projectgroup.upload")}
                      </button>
                    </div>

                    <div className="Expanded_Box">
                      <img className="Project_icon" src={edit_icon} alt="edit" />
                      <button
                        className="ActionButton edit"
                        onClick={(e) => {
                          e.stopPropagation();
                          openPopup("edit", p);
                        }}
                      >
                        {t("projectgroup.edit")}
                      </button>

                      <img
                        className="Project_icon"
                        src={delete_icon}
                        alt="delete"
                      />
                      <button
                        className="ActionButton delete"
                        onClick={(e) => {
                          e.stopPropagation();
                          openPopup("delete", p);
                        }}
                      >
                        {t("projectgroup.delete")}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="No_Project">{t("searchbox.error")}</div>
        )}
      </div>

      {/* ✅ MUI Pagination */}
      {totalPages > 1 && (
        <Stack spacing={2} alignItems="center" sx={{ marginTop: "20px" }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            variant="outlined"
            shape="rounded"
            size="large"
          />
        </Stack>
      )}

      {/* 팝업들 */}
      {showCreateProject && (
        <div className="PopupContainer">
          <AddProjectGroup setShowCreateProject={setShowCreateProject} />
        </div>
      )}
      {/* 프로젝트 이미지 데이터 업로드 팝업 */}
      {activePopup === "upload" && selectedProjectGroup && (
        <div className="PopupContainer">
          <UploadProject
            projectGroupId={selectedProjectGroup.projectGroupId}
            projectName={selectedProjectGroup.projectGroupName}
            onClose={closePopup}
          />
        </div>
      )}
      {/* 프로젝트 그룹 수정 팝업 */}
      {activePopup === "edit" && selectedProjectGroup && (
        <div className="PopupContainer">
          <EditProjectGroup
            projectGroupId={selectedProjectGroup.projectGroupId}
            projectName={selectedProjectGroup.projectGroupName}
            onClose={closePopup}
          />
        </div>
      )}
      {/* 프로젝트 그룹 삭제 팝업 */}
      {activePopup === "delete" && selectedProjectGroup && (
        <div className="PopupContainer">
          <DeleteProjectGroup
            projectGroupId={selectedProjectGroup.projectGroupId}
            projectName={selectedProjectGroup.projectGroupName}
            onClose={closePopup}
            onSuccess={() => setRefreshProjectGroups(prev => !prev)} // ✅ 상위에서 받은 setter로 갱신
          />
        </div>
      )}
    </div>
  );
};

export default ProjectGroup;
